import { render, staticRenderFns } from "./ModalCallConfirmation.vue?vue&type=template&id=4c7175de&scoped=true&"
import script from "./ModalCallConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalCallConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalCallConfirmation.vue?vue&type=style&index=0&id=4c7175de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7175de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
